<template>
  <div 
    class="cpt-red-num-wrapper" 
    ref="red-num" 
    :style="style" 
  >
    <span 
      class="red-num"
      :style="{
        'border-color': borderColor || ''
      }"
      :class="{
        border: isHasBorder || borderColor
      }"
    >
      {{ num > 99 ? '99+' : num }}
    </span>
  </div>
</template>

<script>
export default {
  name: '',
  props: {
    num: {
      default: 0,
    },
    calbox: {
      default: false,
    },
    isHasBorder: {
      default: false,
    },
    borderColor: {
      default: '',
      type: [String, Number],
    }
  },
  data() {
    return {
      style: {},
    }
  },
  mounted() {
    this.init()
  },
  watch: {
    num(v) {
      this.init()
    }
  },
  methods: {
    init() {
      if (!this.calbox) return
      this.style = {}
      this.$nextTick(() => {
        if(!this.$refs['red-num']) return;
        if (this.$refs['red-num'].offsetWidth > 0 && this.$refs['red-num'].offsetHeight > 0) {
          this.style = {
            width: this.$refs['red-num'].offsetWidth / 2 + 'px',
            height: this.$refs['red-num'].offsetHeight / 2 + 'px'
          }
        } else {
          this.style = {
            width: '16px',
            height: '16px'
          }
        }
      })
    }
  }
}
</script>

<style lang="scss">
.cpt-red-num-wrapper {
  border-radius: 9px;
  pointer-events: none;
  .red-num {
    width: fit-content;
    min-width: 32px;
    padding: 0 8px;
    background: $d-er-fl;
    border-radius: 16px;
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 500;
    font-size: 22px;
    line-height: 32px;
    letter-spacing: 0.01em;
    color: $ct-wh-0;
    text-align: center;
    transform: scale(.5);
    transform-origin: left top;
    display: block;
    &.border {
      border: 4px $d-fl-nv solid;
    }
  }
}
</style>